import { ADD_ADDRESS_SUCCESS, ADD_ADDRESS_REQUEST, ADD_ADDRESS_FAILURE, ADD_ADDRESS_RESET } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const addAddressReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ADDRESS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case ADD_ADDRESS_REQUEST:
            return Object.assign({}, state);
        case ADD_ADDRESS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case ADD_ADDRESS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default addAddressReducer;
